import Axios, { AxiosResponse } from "axios";
import defineHeaderAxios from "@/utilities/useAuthToken";
import VIPContactViewModel from "@/models/VIPContactViewModel";
export default function () {
    const add = async (contact: VIPContactViewModel): Promise<void> => {
        await defineHeaderAxios();
        return new Promise((resolve, reject) => {
            Axios.post("/api/vipcontact", contact)
                .then((result: AxiosResponse) => {
                    if (result.status === 200) {
                        resolve();
                    } else {
                        reject();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    reject();
                });
        });
    };
    const update = async (contact: VIPContactViewModel): Promise<void> => {
        await defineHeaderAxios();
        return new Promise((resolve, reject) => {
            Axios.put(`/api/vipcontact/${contact.id}`, contact)
                .then((result: AxiosResponse) => {
                    if (result.status === 200) {
                        resolve();
                    } else {
                        reject();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    reject();
                });
        });
    };
    const remove = async (id: number): Promise<void> => {
        await defineHeaderAxios();
        return new Promise((resolve, reject) => {
            Axios.delete(`/api/vipcontact/${id}`)
                .then((result: AxiosResponse) => {
                    if (result.status === 200) {
                        resolve();
                    } else {
                        reject();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    reject();
                });
        });
    };
    const get = async (id: number): Promise<VIPContactViewModel> => {
        await defineHeaderAxios();
        return new Promise((resolve, reject) => {
            Axios.get(`/api/vipcontact/${id}`)
                .then((result: AxiosResponse<VIPContactViewModel>) => {
                    if (result.status === 200) {
                        resolve(result.data);
                    } else {
                        reject();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    reject();
                });
        });
    };

    const nameRules: ((v: any) => any)[] = [
        (v) => !!v || "Name is required",
        (v) => (v && v.length <= 30) || "Name must be less than 30 characters",
    ];
    const emailRules: ((v: any) => any)[] = [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ];
    return {
        add,
        update,
        remove,
        get,
        nameRules,
        emailRules,
    };
}
